{
 "version": 7,
 "notes": "kind: same = identical answers match; ordinal = partial credit for adjacent answers; complement = opposite answers match (2 options); custom = explicit matrix M[a][b] in [0,1]. weight defaults to 1.",
 "questions": [
  {
   "id": "topsheet",
   "prompt": "Top sheet:",
   "options": [
    "Essential",
    "Pointless",
    "What is a top sheet"
   ],
   "kind": "same",
   "core": true
  },
  {
   "id": "hotdog",
   "prompt": "A hot dog is a sandwich.",
   "options": [
    "Obviously",
    "Absolutely not",
    "I refuse to participate in this"
   ],
   "kind": "same",
   "active": false
  },
  {
   "id": "late",
   "prompt": "How many minutes late is actually late?",
   "options": [
    "1",
    "5",
    "15",
    "30",
    "Late is a state of mind"
   ],
   "kind": "ordinal",
   "core": true
  },
  {
   "id": "shower_beer",
   "prompt": "Shower beer:",
   "options": [
    "Yes",
    "No",
    "Shower coffee, actually"
   ],
   "kind": "same",
   "core": true
  },
  {
   "id": "pillows",
   "prompt": "Correct number of pillows on a bed:",
   "options": [
    "1",
    "2",
    "4",
    "So many you can't find the bed"
   ],
   "kind": "ordinal",
   "active": false
  },
  {
   "id": "texts_first",
   "prompt": "After a good first hang, who texts first?",
   "options": [
    "Me, immediately",
    "I wait for them"
   ],
   "kind": "complement",
   "notes": "one texter + one waiter = harmony; two waiters = nothing ever happens",
   "core": true,
   "active": false
  },
  {
   "id": "is_it_a_date",
   "prompt": "It's a date if nobody said the word \"date.\"",
   "options": [
    "Yes, obviously",
    "No, use your words",
    "Depends who paid"
   ],
   "kind": "same",
   "active": false
  },
  {
   "id": "ex_photos",
   "prompt": "Keeping photos of an ex on your phone is:",
   "options": [
    "Fine, it's history",
    "Delete them, coward",
    "Fine, but not as the lock screen"
   ],
   "kind": "same",
   "active": false
  },
  {
   "id": "cilantro",
   "prompt": "Cilantro:",
   "options": [
    "Delicious",
    "Tastes like soap",
    "Never noticed it"
   ],
   "kind": "same",
   "active": false
  },
  {
   "id": "spice",
   "prompt": "How spicy do you want it?",
   "options": [
    "Mild",
    "Medium",
    "Hot",
    "I want to see God"
   ],
   "kind": "ordinal",
   "core": true,
   "active": false
  },
  {
   "id": "pineapple_pizza",
   "prompt": "Pineapple on pizza:",
   "options": [
    "Yes",
    "No",
    "Only if someone else ordered it"
   ],
   "kind": "same",
   "active": false
  },
  {
   "id": "wake_time",
   "prompt": "Natural wake-up time with no alarm:",
   "options": [
    "Before 7",
    "7 to 9",
    "9 to 11",
    "Noon and I'm not sorry"
   ],
   "kind": "ordinal",
   "core": true,
   "active": false
  },
  {
   "id": "big_spoon",
   "prompt": "Big spoon or little spoon?",
   "options": [
    "Big spoon",
    "Little spoon"
   ],
   "kind": "complement",
   "core": true
  },
  {
   "id": "thermostat",
   "prompt": "Thermostat at night:",
   "options": [
    "Freezing, pile on blankets",
    "Comfortable",
    "Tropical"
   ],
   "kind": "ordinal",
   "active": false
  },
  {
   "id": "party_exit",
   "prompt": "How do you leave a party?",
   "options": [
    "Say goodbye to everyone",
    "Irish exit",
    "I am always the last to leave"
   ],
   "kind": "same",
   "core": true
  },
  {
   "id": "karaoke",
   "prompt": "Karaoke:",
   "options": [
    "I have a signature song",
    "Only after three drinks",
    "Never, under any circumstances"
   ],
   "kind": "ordinal",
   "active": false
  },
  {
   "id": "superpower",
   "prompt": "Pick one:",
   "options": [
    "Talk to animals",
    "Fluent in every language",
    "Never need sleep",
    "Always find parking"
   ],
   "kind": "same",
   "active": false
  },
  {
   "id": "dishes",
   "prompt": "Dishes in the sink overnight:",
   "options": [
    "Unacceptable",
    "Fine, it's soaking",
    "What's a sink"
   ],
   "kind": "ordinal",
   "core": true
  },
  {
   "id": "planner",
   "prompt": "Vacation style:",
   "options": [
    "Itinerary with time slots",
    "Loose plan, one thing a day",
    "Wake up and see what happens"
   ],
   "kind": "ordinal",
   "core": true,
   "active": false
  },
  {
   "id": "cook_or_clean",
   "prompt": "Cook or clean?",
   "options": [
    "Cook",
    "Clean"
   ],
   "kind": "complement",
   "core": true
  },
  {
   "id": "movie_talk",
   "prompt": "Talking during movies:",
   "options": [
    "Never",
    "Only at home",
    "Commentary is half the fun"
   ],
   "kind": "ordinal",
   "core": true,
   "active": false
  },
  {
   "id": "pet",
   "prompt": "Ideal animal roommate:",
   "options": [
    "Dog",
    "Cat",
    "Something with scales",
    "None, I like my stuff intact"
   ],
   "kind": "same",
   "core": true,
   "active": false
  },
  {
   "id": "birthday",
   "prompt": "Your birthday should be:",
   "options": [
    "A big deal",
    "Dinner with a few people",
    "Ignored, please"
   ],
   "kind": "ordinal",
   "core": true
  },
  {
   "id": "flirt",
   "prompt": "Your flirting style is best described as:",
   "options": [
    "Relentless teasing",
    "Deeply sincere compliments",
    "I do not flirt, I lecture",
    "Unclear if it's happening"
   ],
   "kind": "same",
   "core": true
  },
  {
   "id": "reply_speed",
   "prompt": "Acceptable time to leave a text on read:",
   "options": [
    "Minutes",
    "Hours",
    "Days",
    "Read receipts are off, obviously"
   ],
   "kind": "ordinal",
   "active": false
  },
  {
   "id": "tattoos",
   "prompt": "Tattoos:",
   "options": [
    "Have several",
    "Have one with a story",
    "Considering it",
    "Not for me"
   ],
   "kind": "ordinal",
   "active": false
  },
  {
   "id": "ghost",
   "prompt": "Would you sleep in a house that's definitely haunted for $10,000?",
   "options": [
    "Yes, easily",
    "Yes, but I'd hate it",
    "No amount of money"
   ],
   "kind": "ordinal",
   "active": false
  },
  {
   "id": "drive_or_navigate",
   "prompt": "Road trip: driver or DJ?",
   "options": [
    "Driver",
    "DJ"
   ],
   "kind": "complement",
   "active": false
  },
  {
   "id": "brunch",
   "prompt": "Brunch is:",
   "options": [
    "The best meal of the week",
    "Overpriced eggs",
    "Fine if there's a wait under 20 minutes"
   ],
   "kind": "same",
   "active": false
  },
  {
   "id": "gossip",
   "prompt": "Gossip:",
   "options": [
    "I'm the source",
    "I'm the audience",
    "Above it (lying)",
    "Genuinely above it"
   ],
   "kind": "custom",
   "matrix": [
    [
     0.6,
     1.0,
     0.3,
     0.0
    ],
    [
     1.0,
     0.7,
     0.4,
     0.1
    ],
    [
     0.3,
     0.4,
     0.8,
     0.5
    ],
    [
     0.0,
     0.1,
     0.5,
     1.0
    ]
   ],
   "notes": "source + audience is the ideal pairing; two sources compete",
   "core": true
  },
  {
   "id": "one_song",
   "prompt": "Same song on repeat for a whole car ride:",
   "options": [
    "Yes, it slaps",
    "Once, then we move on",
    "That is a hostage situation"
   ],
   "kind": "ordinal",
   "active": false
  },
  {
   "id": "aliens",
   "prompt": "Aliens:",
   "options": [
    "Already here",
    "Out there somewhere",
    "Just us, sorry"
   ],
   "kind": "ordinal",
   "active": false
  },
  {
   "id": "diary",
   "prompt": "You could read their phone, and you'd never be caught.",
   "options": [
    "I wouldn't want to",
    "I wouldn't, but I'd think about it",
    "I'd read it",
    "I've done it"
   ],
   "kind": "ordinal"
  },
  {
   "id": "correct_story",
   "prompt": "Someone's telling a story and gets a small detail wrong.",
   "options": [
    "Let it go",
    "Correct them quietly, after",
    "Correct them immediately"
   ],
   "kind": "ordinal",
   "active": false
  },
  {
   "id": "bad_partner",
   "prompt": "Your closest friend's new partner is bad news.",
   "options": [
    "Say it plainly, once",
    "Hint and hope they hear it",
    "Say nothing — not my call"
   ],
   "kind": "ordinal"
  },
  {
   "id": "check_split",
   "prompt": "The check comes. Everyone's splitting evenly and you ordered the cheap thing.",
   "options": [
    "Split it, it evens out",
    "Split it, quietly annoyed",
    "Say something"
   ],
   "kind": "ordinal",
   "active": false
  },
  {
   "id": "death_date",
   "prompt": "You can be told the exact date of your death.",
   "options": [
    "Tell me",
    "Don't tell me",
    "Only if it's far away"
   ],
   "kind": "same"
  },
  {
   "id": "perceived",
   "prompt": "Someone will tell you one true thing about how people see you.",
   "options": [
    "Yes, obviously",
    "No thank you",
    "Only the flattering half"
   ],
   "kind": "same"
  },
  {
   "id": "crush_cheating",
   "prompt": "Having a crush on someone else is cheating.",
   "options": [
    "Yes",
    "No",
    "Only if you'd act on it"
   ],
   "kind": "same",
   "active": false
  },
  {
   "id": "exes_friends",
   "prompt": "Someone you're seeing is close friends with all their exes.",
   "options": [
    "Green flag",
    "Red flag",
    "Depends entirely on the exes"
   ],
   "kind": "same",
   "active": false
  },
  {
   "id": "grudge",
   "prompt": "How long do you hold a grudge?",
   "options": [
    "I don't hold them",
    "About a day",
    "Years",
    "I'm holding one right now"
   ],
   "kind": "ordinal",
   "active": false
  },
  {
   "id": "hard_conversation",
   "prompt": "There's a hard conversation coming.",
   "options": [
    "Get it over with today",
    "Rehearse it for a week",
    "Hope it resolves itself"
   ],
   "kind": "ordinal",
   "active": false
  },
  {
   "id": "dishwasher",
   "prompt": "Loading the dishwasher:",
   "options": [
    "There's a right way and I know it",
    "Any way it fits",
    "I have a system and I will explain it to you"
   ],
   "kind": "same",
   "core": true
  },
  {
   "id": "group_chat",
   "prompt": "Your role in the group chat:",
   "options": [
    "The engine",
    "Reliable responder",
    "Lurker",
    "I muted it"
   ],
   "kind": "custom",
   "matrix": [
    [
     0.4,
     1.0,
     0.7,
     0.0
    ],
    [
     1.0,
     0.8,
     0.5,
     0.2
    ],
    [
     0.7,
     0.5,
     0.6,
     0.5
    ],
    [
     0.0,
     0.2,
     0.5,
     0.9
    ]
   ],
   "notes": "an engine needs an audience; two engines talk over each other; a muter is nobody's match",
   "core": true,
   "active": false
  },
  {
   "id": "voice_memos",
   "prompt": "Voice memos:",
   "options": [
    "Love them",
    "Only from certain people",
    "A war crime"
   ],
   "kind": "ordinal"
  },
  {
   "id": "first_to_party",
   "prompt": "You're the first to arrive at the party.",
   "options": [
    "Great, I'll help set up",
    "Circle the block until someone else shows",
    "Has never once happened to me"
   ],
   "kind": "same",
   "active": false
  },
  {
   "id": "dance",
   "prompt": "Dancing:",
   "options": [
    "Unprompted",
    "After a drink or two",
    "Weddings only",
    "Structurally incapable"
   ],
   "kind": "ordinal",
   "active": false
  },
  {
   "id": "beer",
   "prompt": "Do you like the taste of beer?",
   "options": [
    "Yes",
    "No",
    "I've learned to"
   ],
   "kind": "same",
   "active": false
  },
  {
   "id": "tabs",
   "prompt": "Browser tabs open right now:",
   "options": [
    "Under ten",
    "Ten to thirty",
    "Too many to read the titles",
    "I opened a second browser to escape them"
   ],
   "kind": "ordinal",
   "active": false
  },
  {
   "id": "wake_3am",
   "prompt": "You're awake at 3am and it isn't going away.",
   "options": [
    "Lie there and take it",
    "Phone",
    "Get up and do something",
    "This doesn't happen to me"
   ],
   "kind": "same",
   "active": false
  },
  {
   "id": "hotel_bed",
   "prompt": "Work trip with a friend, one bed left.",
   "options": [
    "Fine, obviously",
    "Fine, but I'd mention it first",
    "I'd get another room"
   ],
   "kind": "ordinal",
   "active": false
  },
  {
   "id": "pda",
   "prompt": "Public displays of affection:",
   "options": [
    "Hand-holding, maximum",
    "Depends who's watching",
    "“Get a room” is a compliment"
   ],
   "kind": "ordinal",
   "active": false
  },
  {
   "id": "first_kiss",
   "prompt": "Kissing on the first date:",
   "options": [
    "Yes",
    "No",
    "Depends how it went"
   ],
   "kind": "same",
   "active": false
  },
  {
   "id": "first_night",
   "prompt": "Going home together on the first date:",
   "options": [
    "Sure",
    "Never",
    "Depends entirely on the date"
   ],
   "kind": "same",
   "spicy": true
  },
  {
   "id": "say_what_you_like",
   "prompt": "Saying out loud what you like in bed:",
   "options": [
    "Plainly, early",
    "Eventually, once I trust you",
    "I would rather guess forever"
   ],
   "kind": "ordinal",
   "spicy": true,
   "active": false
  },
  {
   "id": "lights",
   "prompt": "Lights:",
   "options": [
    "On",
    "Off",
    "Somewhere in between",
    "Whatever's already happening"
   ],
   "kind": "ordinal",
   "spicy": true,
   "notes": "un-retired and widened from 3 options to 4; the first three indices are unchanged so the original ringer answers still apply"
  },
  {
   "id": "same_bed",
   "prompt": "Sleeping in the same bed every single night:",
   "options": [
    "Always",
    "Sometimes apart is nice",
    "Separate rooms, thriving"
   ],
   "kind": "ordinal",
   "spicy": true,
   "active": false
  },
  {
   "id": "post_the_take",
   "prompt": "You have a take.",
   "options": [
    "Post it immediately",
    "Draft it and delete it",
    "I don't post"
   ],
   "kind": "ordinal"
  },
  {
   "id": "wrong_in_replies",
   "prompt": "Someone is wrong in your replies.",
   "options": [
    "Engage",
    "Screenshot it for the group chat",
    "Block",
    "Keep scrolling"
   ],
   "kind": "same"
  },
  {
   "id": "follower_count",
   "prompt": "Your own follower count:",
   "options": [
    "I don't look",
    "I look sometimes",
    "I know it right now"
   ],
   "kind": "ordinal",
   "active": false
  },
  {
   "id": "delete_flop",
   "prompt": "Deleting a post that isn't doing numbers:",
   "options": [
    "Never",
    "I've done it",
    "I'd do it again tonight"
   ],
   "kind": "ordinal"
  },
  {
   "id": "extremely_online",
   "prompt": "Are you Extremely Online?",
   "options": [
    "No",
    "Yes, and it's fine",
    "Yes, and I'm in recovery"
   ],
   "kind": "same",
   "active": false
  },
  {
   "id": "change_comes_from",
   "prompt": "Change mostly comes from:",
   "options": [
    "Winning elections",
    "Organizing outside them",
    "Both, and I'm tired of the argument"
   ],
   "kind": "same"
  },
  {
   "id": "ally_bad_argument",
   "prompt": "Someone on your side makes a bad argument for a conclusion you agree with.",
   "options": [
    "Correct them publicly",
    "Correct them privately",
    "Let it go — we need the win"
   ],
   "kind": "ordinal",
   "active": false
  },
  {
   "id": "thanksgiving",
   "prompt": "Arguing politics with family:",
   "options": [
    "I go in",
    "Only if they start it",
    "Never, pass the potatoes"
   ],
   "kind": "ordinal"
  },
  {
   "id": "insufferable_poster",
   "prompt": "An account that's right about everything and insufferable about it.",
   "options": [
    "Follow anyway",
    "Mute but keep following",
    "Unfollow"
   ],
   "kind": "ordinal",
   "active": false
  },
  {
   "id": "compromise",
   "prompt": "Compromise is:",
   "options": [
    "How anything gets done",
    "How you lose slowly",
    "Fine, but not on this"
   ],
   "kind": "same",
   "active": false
  },
  {
   "id": "monogamy",
   "prompt": "Monogamy is:",
   "options": [
    "The only way I work",
    "Right for me, not for everyone",
    "One option among several",
    "Negotiable"
   ],
   "kind": "ordinal",
   "spicy": true,
   "active": false
  },
  {
   "id": "body_count",
   "prompt": "Does the number of people someone's slept with matter to you?",
   "options": [
    "Not at all",
    "A little",
    "Yes"
   ],
   "kind": "ordinal",
   "spicy": true,
   "active": false
  },
  {
   "id": "porn",
   "prompt": "Porn:",
   "options": [
    "Fine, no notes",
    "Fine in moderation",
    "I'd rather a partner didn't",
    "Not in my life"
   ],
   "kind": "ordinal",
   "spicy": true,
   "active": false
  },
  {
   "id": "nudes",
   "prompt": "Sending nudes:",
   "options": [
    "Enthusiastically",
    "To the right person",
    "Never — phones get hacked"
   ],
   "kind": "ordinal",
   "spicy": true
  },
  {
   "id": "threesome",
   "prompt": "A threesome:",
   "options": [
    "Yes",
    "Curious",
    "No thanks"
   ],
   "kind": "ordinal",
   "spicy": true,
   "active": false
  },
  {
   "id": "kink",
   "prompt": "Kink:",
   "options": [
    "I have a list",
    "Game to try things",
    "Vanilla and content"
   ],
   "kind": "ordinal",
   "spicy": true
  },
  {
   "id": "frequency",
   "prompt": "Ideally, how often?",
   "options": [
    "Daily",
    "A few times a week",
    "Weekly-ish",
    "Rarely, and that's fine"
   ],
   "kind": "ordinal",
   "spicy": true,
   "active": false
  },
  {
   "id": "toys",
   "prompt": "Toys:",
   "options": [
    "Yes",
    "Open to it",
    "No thanks"
   ],
   "kind": "ordinal",
   "spicy": true,
   "active": false
  },
  {
   "id": "loud",
   "prompt": "Are you loud?",
   "options": [
    "Yes",
    "No",
    "My neighbours would say yes"
   ],
   "kind": "same",
   "spicy": true,
   "active": false
  },
  {
   "id": "first_move",
   "prompt": "Who makes the first move?",
   "options": [
    "Me",
    "Them"
   ],
   "kind": "complement",
   "spicy": true
  },
  {
   "id": "afterwards",
   "prompt": "Immediately afterwards:",
   "options": [
    "Cuddle",
    "Talk",
    "Snack",
    "Asleep"
   ],
   "kind": "same",
   "spicy": true
  },
  {
   "id": "friend_hookup",
   "prompt": "Sleeping with a friend is:",
   "options": [
    "A great idea",
    "A terrible idea",
    "Entirely friend-dependent"
   ],
   "kind": "same",
   "spicy": true
  },
  {
   "id": "romantasy",
   "prompt": "Romantasy:",
   "options": [
    "I have a whole shelf",
    "I've read a few",
    "Not my thing",
    "What's romantasy"
   ],
   "kind": "same"
  },
  {
   "id": "fanfic",
   "prompt": "Fanfiction:",
   "options": [
    "I read it",
    "I write it",
    "I'd deny it under oath",
    "Never touched it"
   ],
   "kind": "custom",
   "matrix": [
    [
     0.9,
     1.0,
     0.7,
     0.2
    ],
    [
     1.0,
     0.85,
     0.6,
     0.1
    ],
    [
     0.7,
     0.6,
     0.8,
     0.5
    ],
    [
     0.2,
     0.1,
     0.5,
     0.9
    ]
   ],
   "notes": "a reader and a writer are the ideal pairing; a denier and a never are barely speaking"
  },
  {
   "id": "big_butts",
   "prompt": "Be honest: do you like big butts?",
   "options": [
    "I cannot lie",
    "I can lie",
    "I'm more of a shoulders person",
    "No strong feelings"
   ],
   "kind": "same",
   "spicy": true
  },
  {
   "id": "dirty_talk",
   "prompt": "Dirty talk:",
   "options": [
    "Fluent",
    "A little goes a long way",
    "I get shy",
    "Absolutely not"
   ],
   "kind": "ordinal",
   "spicy": true
  },
  {
   "id": "morning_or_night",
   "prompt": "Morning or night?",
   "options": [
    "Morning",
    "Night",
    "3pm on a Tuesday"
   ],
   "kind": "same",
   "spicy": true,
   "active": false
  },
  {
   "id": "shower_together",
   "prompt": "Showering together:",
   "options": [
    "Romantic",
    "A logistical nightmare",
    "Depends entirely on the shower"
   ],
   "kind": "same",
   "spicy": true,
   "notes": "un-retired in the third slush-pile pass; wording and options unchanged, so its original ringer answers still apply"
  },
  {
   "id": "blindfold",
   "prompt": "Blindfold:",
   "options": [
    "Yes",
    "Curious",
    "No thanks"
   ],
   "kind": "ordinal",
   "spicy": true,
   "active": false
  },
  {
   "id": "role_play",
   "prompt": "Role play:",
   "options": [
    "Enthusiastically",
    "With the right person",
    "I'd laugh too hard",
    "No"
   ],
   "kind": "ordinal",
   "spicy": true
  },
  {
   "id": "not_a_bed",
   "prompt": "Somewhere that isn't a bed:",
   "options": [
    "Yes",
    "Once was enough",
    "Bed is fine, bed is good"
   ],
   "kind": "ordinal",
   "spicy": true,
   "active": false
  },
  {
   "id": "my_type",
   "prompt": "Your type is:",
   "options": [
    "Consistent, and I know exactly what it is",
    "All over the place",
    "I refuse to believe I have one"
   ],
   "kind": "same",
   "spicy": true,
   "active": false
  },
  {
   "id": "hall_pass",
   "prompt": "The celebrity list:",
   "options": [
    "Written down",
    "Exists in my head",
    "We don't do that",
    "I'd rather not hear theirs"
   ],
   "kind": "same",
   "spicy": true
  },
  {
   "id": "love_you_first",
   "prompt": "Saying it first:",
   "options": [
    "Me, early",
    "Me, eventually",
    "I wait for them"
   ],
   "kind": "ordinal",
   "spicy": true,
   "active": false
  },
  {
   "id": "pet_names",
   "prompt": "Pet names:",
   "options": [
    "Yes, several",
    "One, and it's embarrassing",
    "Use my actual name"
   ],
   "kind": "ordinal",
   "spicy": true,
   "active": false
  },
  {
   "id": "best_muppet",
   "prompt": "Best Muppet:",
   "options": [
    "Kermit",
    "Miss Piggy",
    "Gonzo",
    "Animal"
   ],
   "kind": "same"
  },
  {
   "id": "muppet_christmas",
   "prompt": "The Muppet Christmas Carol is:",
   "options": [
    "The definitive A Christmas Carol",
    "A good Christmas movie",
    "Never seen it"
   ],
   "kind": "ordinal",
   "active": false
  },
  {
   "id": "statler_waldorf",
   "prompt": "Statler and Waldorf are:",
   "options": [
    "Correct",
    "Mean",
    "Me, increasingly"
   ],
   "kind": "same",
   "active": false
  },
  {
   "id": "party_rock",
   "prompt": "“Party Rock Anthem” comes on:",
   "options": [
    "I'm up",
    "Every day I'm shufflin'",
    "I leave"
   ],
   "kind": "same",
   "active": false
  },
  {
   "id": "sexy_and_i_know_it",
   "prompt": "“I'm Sexy and I Know It” is:",
   "options": [
    "A documentary",
    "A banger",
    "A war crime"
   ],
   "kind": "same",
   "active": false
  },
  {
   "id": "nirvana_pearl_jam",
   "prompt": "Nirvana or Pearl Jam?",
   "options": [
    "Nirvana",
    "Pearl Jam",
    "Neither — I was listening to something else"
   ],
   "kind": "same"
  },
  {
   "id": "boy_bands",
   "prompt": "Boy bands:",
   "options": [
    "Backstreet Boys",
    "NSYNC",
    "Neither",
    "Both, obviously"
   ],
   "kind": "same",
   "active": false
  },
  {
   "id": "nineties_floor",
   "prompt": "The 90s song that gets you on the dance floor:",
   "options": [
    "Whoomp! (There It Is)",
    "No Diggity",
    "Believe",
    "Nothing does"
   ],
   "kind": "same"
  },
  {
   "id": "mixtape",
   "prompt": "Making someone a mixtape (or a playlist):",
   "options": [
    "I have, and I labored over it",
    "I have, casually",
    "Never made one",
    "I got one once and still think about it"
   ],
   "kind": "same"
  },
  {
   "id": "lingerie",
   "prompt": "Lingerie:",
   "options": [
    "Yes, mine",
    "Yes, theirs",
    "On the floor within four seconds",
    "Not really a thing for me"
   ],
   "kind": "same",
   "spicy": true
  },
  {
   "id": "hickey",
   "prompt": "A visible hickey:",
   "options": [
    "Fine",
    "At my age?",
    "Depends on the week's meetings"
   ],
   "kind": "same",
   "spicy": true,
   "active": false
  },
  {
   "id": "couple_photos",
   "prompt": "Photos of the two of you that are just for the two of you:",
   "options": [
    "Yes",
    "Never",
    "Only on something with no cloud backup"
   ],
   "kind": "same",
   "spicy": true,
   "active": false
  },
  {
   "id": "mirror",
   "prompt": "A mirror in the bedroom:",
   "options": [
    "Yes",
    "No",
    "Hadn't considered it until just now"
   ],
   "kind": "same",
   "spicy": true,
   "active": false
  },
  {
   "id": "sex_playlist",
   "prompt": "A playlist for it:",
   "options": [
    "Yes, curated",
    "Whatever's already on",
    "Silence, please",
    "Absolutely not"
   ],
   "kind": "ordinal",
   "spicy": true,
   "active": false
  },
  {
   "id": "walked_in",
   "prompt": "Been walked in on:",
   "options": [
    "Yes, and it's a great story",
    "Yes, and we don't discuss it",
    "Never",
    "Not yet"
   ],
   "kind": "same",
   "spicy": true,
   "active": false
  },
  {
   "id": "stay_over",
   "prompt": "The first time, afterwards:",
   "options": [
    "I stay",
    "I go home",
    "Depends entirely on the commute"
   ],
   "kind": "same",
   "spicy": true,
   "active": false
  },
  {
   "id": "tell_friends",
   "prompt": "Telling your friends the details:",
   "options": [
    "Everything",
    "The headline only",
    "Nothing",
    "I only listen to theirs"
   ],
   "kind": "same",
   "spicy": true,
   "active": false
  },
  {
   "id": "ai",
   "prompt": "Generative AI is:",
   "options": [
    "Fine — I use it",
    "Fine for some things",
    "Mostly bad, but here we are",
    "A blight, and I mean it"
   ],
   "kind": "ordinal",
   "weight": 3,
   "core": true,
   "notes": "triple-weighted and always asked early — on Bluesky this is closer to a dealbreaker than a preference"
  },
  {
   "id": "notice_first",
   "prompt": "The first thing you notice about someone:",
   "options": [
    "Their voice",
    "Their hands",
    "How they treat the waiter",
    "Whether they're funny"
   ],
   "kind": "same",
   "core": true,
   "active": false
  },
  {
   "id": "crush_tell",
   "prompt": "When you have a crush, who can tell?",
   "options": [
    "Everyone, immediately",
    "My friends, within the hour",
    "Nobody — I'm a vault",
    "I go cold, which confuses everyone"
   ],
   "kind": "same"
  },
  {
   "id": "ick",
   "prompt": "Instant ick:",
   "options": [
    "Bad tipper",
    "Won't stop talking about their ex",
    "Says “I don't really read”",
    "Rude about their own family"
   ],
   "kind": "same",
   "core": true
  },
  {
   "id": "text_energy",
   "prompt": "Your texting energy:",
   "options": [
    "Paragraphs",
    "Rapid-fire fragments",
    "One reply, twelve hours later",
    "Mostly images"
   ],
   "kind": "same"
  },
  {
   "id": "love_language",
   "prompt": "You feel most loved when someone:",
   "options": [
    "Says it out loud",
    "Fixes something for you",
    "Cancels their plans for you",
    "Puts a hand on your back"
   ],
   "kind": "same",
   "core": true,
   "active": false
  },
  {
   "id": "first_date_spot",
   "prompt": "The ideal first date:",
   "options": [
    "A dark bar",
    "A long walk",
    "Something with an activity",
    "Dinner, properly"
   ],
   "kind": "same",
   "active": false
  },
  {
   "id": "jealousy",
   "prompt": "Jealousy:",
   "options": [
    "I don't really get it",
    "A flicker, and it passes",
    "I feel it and I say so",
    "I feel it and I sit on it"
   ],
   "kind": "ordinal"
  },
  {
   "id": "attracted_to",
   "prompt": "The trait that gets you every time:",
   "options": [
    "Funny",
    "Competent",
    "Kind",
    "A little bit mean"
   ],
   "kind": "same",
   "core": true
  },
  {
   "id": "tension",
   "prompt": "Honestly, the best part is:",
   "options": [
    "The tension beforehand",
    "The first kiss",
    "Everything after that",
    "The next morning"
   ],
   "kind": "same",
   "spicy": true
  },
  {
   "id": "morning_after",
   "prompt": "The morning after:",
   "options": [
    "Breakfast, obviously",
    "Coffee and out the door",
    "I was gone before you woke up",
    "We are not leaving this apartment"
   ],
   "kind": "same",
   "spicy": true
  },
  {
   "id": "kiss_where",
   "prompt": "The best place to be kissed:",
   "options": [
    "Neck",
    "Collarbone",
    "The inside of the wrist",
    "Forehead, and I stand by it"
   ],
   "kind": "same",
   "spicy": true
  },
  {
   "id": "volume",
   "prompt": "Volume:",
   "options": [
    "Silent",
    "Quiet",
    "Vocal",
    "The neighbors have opinions"
   ],
   "kind": "ordinal",
   "spicy": true
  },
  {
   "id": "pet_name",
   "prompt": "Pet names:",
   "options": [
    "Constantly",
    "One, and it's stupid",
    "In private only",
    "Please don't"
   ],
   "kind": "same"
  },
  {
   "id": "love_at_first",
   "prompt": "Love at first sight:",
   "options": [
    "Real",
    "Lust at first sight",
    "A cute lie",
    "It happened to me once"
   ],
   "kind": "same"
  },
  {
   "id": "handwriting",
   "prompt": "They wrote you a letter. On paper.",
   "options": [
    "I'd keep it forever",
    "Sweet, a little much",
    "Nobody has ever done this",
    "I'd write back, longer"
   ],
   "kind": "same"
  },
  {
   "id": "red_flag_ok",
   "prompt": "The red flag you'd overlook:",
   "options": [
    "Bad with money",
    "Still texts their ex",
    "Hates their job, loudly",
    "Terrible taste in movies"
   ],
   "kind": "same",
   "core": true
  },
  {
   "id": "compliment",
   "prompt": "The compliment that actually lands:",
   "options": [
    "You're funny",
    "You're hot",
    "You're smart",
    "You're kind"
   ],
   "kind": "same"
  },
  {
   "id": "their_place",
   "prompt": "First time at their place, you go straight to:",
   "options": [
    "The bookshelf",
    "The fridge",
    "The bathroom cabinet",
    "Nothing — I'm a guest"
   ],
   "kind": "same"
  },
  {
   "id": "break_up",
   "prompt": "Ending things:",
   "options": [
    "In person, always",
    "A phone call is fine",
    "I'd rather fade",
    "I've never been the one who does it"
   ],
   "kind": "ordinal"
  },
  {
   "id": "marks",
   "prompt": "Leaving marks:",
   "options": [
    "Please",
    "Only where nobody sees",
    "Absolutely not",
    "I do the leaving"
   ],
   "kind": "same",
   "spicy": true
  },
  {
   "id": "mirrors",
   "prompt": "Mirrors:",
   "options": [
    "Yes",
    "Startling",
    "Hadn't thought about it",
    "I have now"
   ],
   "kind": "same",
   "spicy": true
  },
  {
   "id": "sexting",
   "prompt": "Sexting:",
   "options": [
    "Fluent",
    "Only when one of us is away",
    "I panic and send a meme",
    "No"
   ],
   "kind": "same",
   "spicy": true
  },
  {
   "id": "their_shirt",
   "prompt": "Their shirt, the morning after:",
   "options": [
    "I'm keeping it",
    "I'd ask first",
    "I brought my own clothes"
   ],
   "kind": "ordinal",
   "spicy": true
  },
  {
   "id": "risky",
   "prompt": "The riskiest yes you'd give:",
   "options": [
    "A car",
    "A bathroom at a party",
    "Someone else's guest room",
    "My own bed, thank you"
   ],
   "kind": "same",
   "spicy": true
  },
  {
   "id": "posting_mode",
   "prompt": "Your posting mode:",
   "options": [
    "Main character",
    "Reply guy",
    "Quote-post critic",
    "Lurker with taste"
   ],
   "kind": "same",
   "core": true
  },
  {
   "id": "block_button",
   "prompt": "The block button is:",
   "options": [
    "A gift",
    "For emergencies",
    "Cowardly",
    "Something that happened to me once and I still think about it"
   ],
   "kind": "same"
  },
  {
   "id": "read_receipts",
   "prompt": "Read receipts:",
   "options": [
    "On — nothing to hide",
    "Off",
    "On, and it's a power move",
    "I don't know what mine are set to"
   ],
   "kind": "same"
  },
  {
   "id": "feed",
   "prompt": "Your feed is:",
   "options": [
    "Following only",
    "Algorithmic, and I've made peace",
    "A curated list",
    "A disaster I refresh anyway"
   ],
   "kind": "same"
  },
  {
   "id": "private_account",
   "prompt": "A private account:",
   "options": [
    "I have one",
    "I had one",
    "I'm too old for this",
    "My whole account is that"
   ],
   "kind": "same"
  },
  {
   "id": "taylor",
   "prompt": "Taylor Swift:",
   "options": [
    "Yes, sincerely",
    "A few songs",
    "I've made my peace",
    "No"
   ],
   "kind": "ordinal"
  },
  {
   "id": "concert",
   "prompt": "At a concert you're:",
   "options": [
    "Front, screaming",
    "Middle, dancing",
    "Back, near the bar",
    "At home watching a video of it"
   ],
   "kind": "ordinal"
  },
  {
   "id": "bad_movie",
   "prompt": "You'd happily watch a bad movie if:",
   "options": [
    "It's bad in the fun way",
    "They love it",
    "I wouldn't",
    "All my favourites are bad movies"
   ],
   "kind": "same"
  },
  {
   "id": "bathroom_door",
   "prompt": "Sharing a bathroom:",
   "options": [
    "Door open, we're fine",
    "Door closed, always",
    "Depends how long it's been"
   ],
   "kind": "ordinal"
  },
  {
   "id": "astrology",
   "prompt": "Astrology:",
   "options": [
    "I already know your chart",
    "Fun, not real",
    "Mild eye-roll",
    "Actively annoyed by it"
   ],
   "kind": "ordinal"
  },
  {
   "id": "ghosts",
   "prompt": "They believe in ghosts:",
   "options": [
    "Charmed",
    "Fine by me",
    "Slightly concerned",
    "We're going to have a problem"
   ],
   "kind": "ordinal"
  },
  {
   "id": "protest",
   "prompt": "Protests:",
   "options": [
    "I go",
    "I've gone",
    "I donate instead",
    "Not my thing"
   ],
   "kind": "ordinal"
  },
  {
   "id": "third_party",
   "prompt": "Voting third party:",
   "options": [
    "Sometimes it's right",
    "Never in a general",
    "I've done it and regret nothing",
    "Let's not"
   ],
   "kind": "same"
  },
  {
   "id": "unsend",
   "prompt": "You can un-send one thing you've ever sent.",
   "options": [
    "I know exactly which one",
    "I'd need a minute",
    "Nothing I'd take back",
    "Too many to choose from"
   ],
   "kind": "same"
  },
  {
   "id": "what_they_think",
   "prompt": "You can hear what one person in the room really thinks of you.",
   "options": [
    "Yes",
    "No",
    "Only if I pick the person",
    "I already know"
   ],
   "kind": "same"
  },
  {
   "id": "secret_keeper",
   "prompt": "A friend tells you a secret that would hurt someone you love.",
   "options": [
    "I tell",
    "I sit on it",
    "I make them tell",
    "Depends who gets hurt"
   ],
   "kind": "same"
  },
  {
   "id": "take_the_money",
   "prompt": "A stranger offers you $10,000 to never speak to your best friend again.",
   "options": [
    "No",
    "I'd think about it",
    "Which friend",
    "I'd take it and keep talking to them"
   ],
   "kind": "same"
  },
  {
   "id": "the_ask",
   "prompt": "Asking for something new in bed:",
   "options": [
    "Straight out",
    "I hint until they get there",
    "I'd rather they asked me",
    "I would sooner die"
   ],
   "kind": "ordinal",
   "spicy": true
  },
  {
   "id": "teeth",
   "prompt": "Teeth:",
   "options": [
    "Yes",
    "Gently",
    "No",
    "Only mine"
   ],
   "kind": "same",
   "spicy": true
  },
  {
   "id": "undress",
   "prompt": "Getting undressed:",
   "options": [
    "Slowly, watched",
    "Fast, lights low",
    "They do it",
    "Separately, like adults"
   ],
   "kind": "same",
   "spicy": true
  },
  {
   "id": "bed_made",
   "prompt": "Making the bed:",
   "options": [
    "Every morning",
    "When someone's coming over",
    "Never — it's going to get slept in again"
   ],
   "kind": "ordinal"
  },
  {
   "id": "shoes_inside",
   "prompt": "Shoes in the house:",
   "options": [
    "Off at the door, always",
    "Off if I remember",
    "On — I'm not weird about it"
   ],
   "kind": "ordinal"
  },
  {
   "id": "mutual_irl",
   "prompt": "Meeting a mutual in real life:",
   "options": [
    "Delighted",
    "Slightly terrified",
    "Done it, it was fine",
    "We should stay in the timeline"
   ],
   "kind": "same"
  },
  {
   "id": "subpost",
   "prompt": "Subposting:",
   "options": [
    "Beneath me",
    "An art form",
    "I've done it and been caught",
    "Just say the name"
   ],
   "kind": "same"
  },
  {
   "id": "dm_slide",
   "prompt": "Sliding into DMs:",
   "options": [
    "That's how it's done",
    "Only if we've talked before",
    "I never would",
    "It's how I met someone"
   ],
   "kind": "same"
  },
  {
   "id": "trek_wars",
   "prompt": "Star Trek or Star Wars?",
   "options": [
    "Trek",
    "Wars",
    "Both",
    "Neither, and stop asking"
   ],
   "kind": "same"
  },
  {
   "id": "comfort_rewatch",
   "prompt": "Your comfort rewatch:",
   "options": [
    "The Office",
    "30 Rock",
    "Parks and Rec",
    "I don't rewatch things"
   ],
   "kind": "same"
  },
  {
   "id": "lotr",
   "prompt": "The Lord of the Rings:",
   "options": [
    "Extended editions, obviously",
    "Theatrical is plenty",
    "Never seen them",
    "Too long either way"
   ],
   "kind": "same"
  },
  {
   "id": "horror",
   "prompt": "Horror movies:",
   "options": [
    "The scarier the better",
    "Only with someone else",
    "Only the funny ones",
    "I won't sleep for a week"
   ],
   "kind": "ordinal"
  },
  {
   "id": "musicals",
   "prompt": "Musicals:",
   "options": [
    "I have opinions about the orchestrations",
    "I like the famous ones",
    "Only if it's funny",
    "No"
   ],
   "kind": "ordinal"
  },
  {
   "id": "separate_art",
   "prompt": "Someone whose work you love turns out to be bad:",
   "options": [
    "I'm done with it",
    "Separate the art",
    "Depends what they did",
    "I'll quietly keep listening"
   ],
   "kind": "same"
  },
  {
   "id": "billionaires",
   "prompt": "Billionaires:",
   "options": [
    "Shouldn't exist",
    "Should be taxed into the ground",
    "Fine, if they earned it",
    "I don't think about them"
   ],
   "kind": "ordinal"
  },
  {
   "id": "in_charge",
   "prompt": "In bed you're:",
   "options": [
    "In charge",
    "Handing over the keys",
    "It swaps",
    "Still negotiating"
   ],
   "kind": "ordinal",
   "spicy": true
  },
  {
   "id": "told_what_to_do",
   "prompt": "Being told what to do:",
   "options": [
    "Yes",
    "Only by the right person",
    "I'd rather do the telling",
    "Neither, thanks"
   ],
   "kind": "same",
   "spicy": true
  },
  {
   "id": "begging",
   "prompt": "Begging:",
   "options": [
    "Love to hear it",
    "Love to do it",
    "Both, depending",
    "Absolutely not"
   ],
   "kind": "same",
   "spicy": true
  },
  {
   "id": "not_the_bed",
   "prompt": "Somewhere other than the bed:",
   "options": [
    "Half the fun",
    "Sounds uncomfortable",
    "The kitchen, specifically",
    "I've tried it and I have notes"
   ],
   "kind": "same",
   "spicy": true
  },
  {
   "id": "clothes_on",
   "prompt": "Clothes staying on:",
   "options": [
    "Sometimes that's the point",
    "Off, all of it",
    "Whatever's in the way"
   ],
   "kind": "ordinal",
   "spicy": true
  },
  {
   "id": "how_it_ends",
   "prompt": "You'd rather it end with:",
   "options": [
    "Both of us asleep",
    "One more round",
    "A shower",
    "Talking until it's light"
   ],
   "kind": "same",
   "spicy": true
  },
  {
   "id": "after_a_fight",
   "prompt": "After a fight:",
   "options": [
    "Yes",
    "Only once it's actually resolved",
    "It's how we resolve it",
    "Not a chance"
   ],
   "kind": "same",
   "spicy": true
  },
  {
   "id": "their_scent",
   "prompt": "Their perfume or cologne left on your clothes:",
   "options": [
    "Best part of the week",
    "Nice",
    "Straight in the wash",
    "I'd know it anywhere"
   ],
   "kind": "same",
   "spicy": true
  },
  {
   "id": "underwear_drawer",
   "prompt": "Your underwear drawer is:",
   "options": [
    "A whole strategy",
    "Function first",
    "A mix — the good ones are for occasions",
    "Not something I've considered"
   ],
   "kind": "same",
   "spicy": true
  },
  {
   "id": "photos_of_us",
   "prompt": "Photos of the two of you that nobody else sees:",
   "options": [
    "There's a folder",
    "I'd delete them after",
    "Absolutely not",
    "There's a folder and I'm nervous about it"
   ],
   "kind": "same",
   "spicy": true
  },
  {
   "id": "flirt_taken",
   "prompt": "Flirting when you're taken:",
   "options": [
    "Harmless",
    "Depends on the flirt",
    "Not if they'd mind",
    "I don't"
   ],
   "kind": "ordinal"
  },
  {
   "id": "dream_about",
   "prompt": "You had a dream about someone you shouldn't have:",
   "options": [
    "I'd tell them",
    "I'd tell my friends",
    "I'd take it to my grave",
    "I'd think about it all week"
   ],
   "kind": "same"
  }
 ]
}